
import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { useIsMobile } from '@/hooks/use-mobile';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    // Check if user has previously accepted cookies
    const consentAccepted = localStorage.getItem('cookie-consent');
    if (!consentAccepted) {
      // Show banner after a short delay
      const timer = setTimeout(() => {
        setShowConsent(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowConsent(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className={`fixed ${isMobile ? 'bottom-0 left-0 right-0 p-4' : 'bottom-6 left-6 right-6 max-w-lg mx-auto p-6'} 
      bg-white shadow-lg rounded-lg border border-gray-200 z-50 animate-fade-in`}>
      <div className="flex items-start justify-between">
        <div>
          <h3 className="text-lg font-bold text-storystore-blue mb-2">Vi använder cookies</h3>
          <p className="text-gray-600 text-sm mb-4">
            Vi använder cookies för att förbättra din upplevelse på vår webbplats. 
            Genom att fortsätta använda vår webbplats godkänner du vår användning av cookies.
          </p>
        </div>
        <button 
          onClick={declineCookies}
          className="text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Stäng cookie-meddelande"
        >
          <X size={20} />
        </button>
      </div>
      
      <div className="flex flex-wrap gap-3">
        <Button
          onClick={acceptCookies}
          className="bg-storystore-red hover:bg-storystore-red/90 text-white" 
        >
          Acceptera alla
        </Button>
        <Button
          onClick={declineCookies}
          variant="outline"
        >
          Endast nödvändiga
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;
